<template>
  <b-row>
    <b-col>
      <label>Sélectionnez le propriétaire du bâtiment à représenter</label>
      <appMultiselectOwners
        :options="options"
        @onSelect="setMandate"
        @onOpen="onOpenSelect"
        @onClose="onCloseSelect"
      />
    </b-col>
  </b-row>
</template>

<script>
import appMultiselectOwners from "@/components/snippets/MultiselectOwners";

import meetingPresenceSelectOptionsMixins from "@/mixins/meeting-presence-select-options";
export default {
  components: {
    appMultiselectOwners,
  },
  mixins: [meetingPresenceSelectOptionsMixins],
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    setMandate(selectedOwner) {
      this.$emit("setMandate", selectedOwner.id);
    },
    onOpenSelect() {
      this.$emit("onOpenSelect");
    },
    onCloseSelect() {
      this.$emit("onCloseSelect");
    },
  },
};
</script>
